import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  createContext,
  useMemo,
} from 'react';
import { useAuth } from 'hooks/auth';
import { useQualidadeCafe } from 'hooks/providers/configuracoes/qualidade';

const SelectQuantidadeContext = createContext({});

export function SelectQuantidadeProvider({ children }) {
  const { isAuth, token } = useAuth();
  const { addQualidade, editQualidade } = useQualidadeCafe();

  const [dados, setDados] = useState({});
  const [options, setOptions] = useState([]);

  const onSubmitInsert = useCallback(
    async (data, onChange) => {
      try {
        const response = await addQualidade(data);

        if (response) {
          setDados(response);
          setOptions((old) => [...old, response]); // Corrigido aqui, evitar chamar setOptions dentro setOptions
          onChange(response);
        }
      } finally {
      }
    },
    [addQualidade],
  );

  const onSubmitUpdate = useCallback(
    async (id, data, onChange) => {
      try {
        const response = await editQualidade(id, data);

        if (response) {
          setOptions((old) =>
            old.map((item) =>
              Number(item.id) === Number(response.id)
                ? {
                    ...item,
                    descricao: response.descricao,
                    codigo: response.codigo,
                    observacao: response.observacao,
                    is_vendavel: response.is_vendavel,
                  }
                : item,
            ),
          );
          setDados(response);
          onChange(response);
        }
      } finally {
      }
    },
    [editQualidade],
  );

  useEffect(() => {
    if (!isAuth && token === 'initial') {
      setDados([]);
    }
  }, [isAuth, token]);

  const value = useMemo(
    () => ({
      onSubmitInsert,
      onSubmitUpdate,
      dados,
      setDados,
      options,
      setOptions,
    }),
    [onSubmitInsert, onSubmitUpdate, dados, options],
  );

  return (
    <SelectQuantidadeContext.Provider value={value}>
      {children}
    </SelectQuantidadeContext.Provider>
  );
}

export function useSelectQuantidade() {
  const context = useContext(SelectQuantidadeContext);

  if (!context)
    throw new Error('useSelectQuantidade must be used within an AuthProvider');

  return context;
}
